import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import api from "../utils/api";


export default function UploadLicense() {
  const [file, setFile] = useState(null);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr("");
    if (!file) { setErr("Choose a file"); return; }

    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("type", "license_certificate");
      await api.post("/auth/documents", fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setMsg("✅ Licence uploaded. We’ll review soon.");
      setTimeout(() => navigate("/seller/dashboard"), 1000);
    } catch (e) {
      setErr(e?.response?.data?.error || "Upload failed");
    }
  };

  return (
    <div className="dashboard-content">
      {msg && <div className="toast">{msg}</div>}
      {err && <div className="toast error">{err}</div>}
      <section className="card" style={{ maxWidth: 520, margin: "2rem auto" }}>
        <h3>Upload your licence certificate</h3>
        <form className="add-form" onSubmit={submit}>
          <input
            ref={inputRef}
            type="file"
            accept="application/pdf,image/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
          <button className="btn" type="submit">Upload</button>
        </form>
      </section>
    </div>
  );
}

